import React from 'react'
import { SegmentedResultHeader } from '../View/SegmentedMeetingResultView'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { AiResult, SegmentedResult } from '../../../../../../../models/AiResult'
import { StructuredSummaryMeetingResultEditView } from './StructuredSummaryMeetingResultEditView'

interface SegmentedMeetingResultEditViewProps {
  aiResult: AiResult
  aiFeature: AiFeature
  onResultTextContentChange: (basePath: string, path: string, resultTextContent: string | boolean) => void
  onFormattedResultChange: (basePath: string, path: string, contentType: string, content: string) => void
}

export const SegmentedMeetingResultEditView: React.FC<SegmentedMeetingResultEditViewProps> = ({
  aiResult,
  aiFeature,
  onResultTextContentChange,
  onFormattedResultChange,
}) => {
  const result = aiResult.result as SegmentedResult

  const { segmentResults } = result

  const segmentCount =
    Math.max(
      ...segmentResults.map((segmentResult) => {
        return segmentResult.metadata.segmentIdx
      }),
    ) + 1

  return (
    <div className='d-flex flex-column gap-3'>
      {segmentResults.map((segmentResult, segmentIdx) => {
        const { results, metadata } = segmentResult
        return (
          <div key={segmentIdx} className='d-flex flex-column'>
            <SegmentedResultHeader segmentCount={segmentCount} metadata={metadata} />
            {results.map((result, resultIdx) => {
              if (result.type !== 'structuredSummary') {
                return null
              }
              const basePath = `$.segmentResults[${segmentIdx}]["results"][${resultIdx}]`
              const resultPath = '$.result'
              return (
                <StructuredSummaryMeetingResultEditView
                  key={basePath}
                  aiResult={aiResult}
                  aiFeature={aiFeature}
                  basePath={basePath}
                  path={resultPath}
                  onResultTextContentChange={onResultTextContentChange}
                  onFormattedResultChange={onFormattedResultChange}
                />
              )
            })}
          </div>
        )
      })}
    </div>
  )
}
